var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 567,
    height: 634,
    viewBox: "0 0 567 634",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M433.333 96.1584C503.76 144.158 550 225.013 550 316.669C550 463.946 430.61 583.336 283.333 583.336C269.66 583.336 256.227 582.306 243.107 580.322M266.667 616.669L243.107 580.322L275.203 550.002M321.997 52.7851C309.373 50.9514 296.463 50.0024 283.333 50.0024C136.057 50.0024 16.6667 169.393 16.6667 316.669C16.6667 406.936 61.5177 486.729 130.15 534.976M300 83.3357L321.997 52.7851L300 16.6691M183.333 316.669L250 383.336L383.333 250.002",
    stroke: "#3CB4E5",
    strokeWidth: 33.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/sync.8a5f81be6c99d1da8a84ea74ce8f3e56.svg";
export { ForwardRef as ReactComponent };